import { render } from "./ASFooter.vue?vue&type=template&id=39311f22&scoped=true"
import script from "./ASFooter.vue?vue&type=script&lang=js"
export * from "./ASFooter.vue?vue&type=script&lang=js"

import "./ASFooter.vue?vue&type=style&index=0&id=39311f22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39311f22"]])

export default __exports__